import { Play, Pause, Loader2, ExternalLink } from "lucide-react";
import { classNames } from "@/utils/classNames";

function PlayIcon({ isLoading, isActive, isPlaying }) {
  if (isLoading) return <Loader2 size={22} className="rh-spin" />;
  if (isActive && isPlaying) return <Pause size={22} />;
  return <Play size={22} />;
}

export function RadioCardOverlay({ isActive, isPlaying, isLoading }) {
  const label = isActive && isPlaying ? "ON AIR" : "LIVE";
  return (
    <>
      <div className="rh-card-overlay" />
      <div className={classNames("rh-card-badge", isActive && isPlaying && "live")}>
        <span className="rh-pulse" />
        {label}
      </div>
      <div className="rh-card-play">
        <PlayIcon isLoading={isLoading} isActive={isActive} isPlaying={isPlaying} />
      </div>
    </>
  );
}

export function PwaLink({ radio }) {
  if (!radio.external_url) return null;
  const label = radio.owned ? "Ouvrir la PWA" : "Site officiel";
  const tag = radio.owned ? "PWA" : "Site";
  return (
    <a
      href={radio.external_url}
      target="_blank"
      rel="noreferrer"
      className="rh-card-ext"
      onClick={(e) => e.stopPropagation()}
      aria-label={label}
      title={label}
      data-testid={`card-ext-link-${radio.id}`}
    >
      <ExternalLink size={13} />
      <span>{tag}</span>
    </a>
  );
}

export function RadioCardTrack({ isPlaceholder, hasTrack, artist, title, tagline }) {
  if (isPlaceholder) {
    return <span className="rh-track-tagline">Réservez ce slot</span>;
  }
  if (hasTrack) {
    return (
      <>
        <span className="rh-track-title">{title || "—"}</span>
        {artist && <span className="rh-track-artist">{artist}</span>}
      </>
    );
  }
  return <span className="rh-track-tagline">{tagline}</span>;
}
